import { Button } from "@/components/ui/button"
import { motion, AnimatePresence } from "framer-motion"
import { useState } from "react"
import confetti from 'canvas-confetti'

interface FormData {
  nome_completo: string;
  email: string;
  whatsapp: string;
  empresa: string;
  cargo?: string;
}

export default function EnhancedHome() {
  const [formData1, setFormData1] = useState<FormData>({
    nome_completo: '',
    email: '',
    whatsapp: '',
    empresa: '',
  });

  // const [formData2, setFormData2] = useState<FormData>({
  //   nome_completo: '',
  //   email: '',
  //   whatsapp: '',
  //   empresa: '',
  //   cargo: '',
  // });

  const [isSubmitting1, setIsSubmitting1] = useState(false);
  //const [isSubmitting2, setIsSubmitting2] = useState(false);
  const [isSuccess1, setIsSuccess1] = useState(false);
 // const [isSuccess2, setIsSuccess2] = useState(false);
  const [error1, setError1] = useState('');
 // const [error2, setError2] = useState('');

  const triggerConfetti = () => {
    const duration = 3 * 1000;
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };
    const randomInRange = (min: number, max: number) => Math.random() * (max - min) + min;

    const interval: any = setInterval(() => {
      const particleCount = 50;
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }
      });
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }
      });
    }, 250);

    setTimeout(() => clearInterval(interval), duration);
  };

  const handleSubmit1 = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting1(true);
    setError1('');

    try {
      const whatsappNumber = formData1.whatsapp.replace(/\D/g, '');
      
      const response = await fetch('https://backend.testeswaffle.org/webhooks/ahead', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData1,
          whatsapp: Number(whatsappNumber),
          form_section: 1
        }),
      });

      if (!response.ok) {
        throw new Error('Erro ao enviar formulário');
      }

      setIsSuccess1(true);
      triggerConfetti();
      setTimeout(() => {
        setIsSuccess1(false);
        window.location.href = "https://api.whatsapp.com/send?phone=5511920905478&text=Ol%C3%A1%2C%20quero%20entrar%20na%20lista%20dos%20interessados%20no%20evento%20do%20the%20news%2C%20por%20favor";
      }, 2000);
    } catch (err) {
      setError1('Erro ao enviar formulário. Tente novamente.');
    } finally {
      setIsSubmitting1(false);
    }
  };

  // const handleSubmit2 = async (e: React.FormEvent<HTMLFormElement>) => {
  //   e.preventDefault();
  //   setIsSubmitting2(true);
  //   setError2('');

  //   try {
  //     const whatsappNumber = formData2.whatsapp.replace(/\D/g, '');
      
  //     const response = await fetch('https://backend.testeswaffle.org/webhooks/ahead', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         ...formData2,
  //         whatsapp: Number(whatsappNumber),
  //         form_section: 2
  //       }),
  //     });

  //     if (!response.ok) {
  //       throw new Error('Erro ao enviar formulário');
  //     }

  //     setIsSuccess2(true);
  //     triggerConfetti();
  //     setTimeout(() => {
  //       setIsSuccess2(false);
  //       window.location.href = "https://api.whatsapp.com/send?phone=5511920905478&text=Ol%C3%A1%2C%20quero%20entrar%20na%20lista%20dos%20interessados%20no%20evento%20ahead%20by%20the%20news%2C%20por%20favor";
  //     }, 2000);
  //   } catch (err) {
  //     setError2('Erro ao enviar formulário. Tente novamente.');
  //   } finally {
  //     setIsSubmitting2(false);
  //   }
  // };

  const scrollToForm = () => {
    const formElement = document.getElementById('interesse-form');
    if (formElement) {
      const offset = 250;
      const elementPosition = formElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const takeMe = () => { 
    window.location.href = "https://api.whatsapp.com/send?phone=5511920905478&text=Quero%20muito%20ser%20speaker%20no%20evento%20do%20the%20news%20de%2006%2F06.";
  }
  return (
    <main className="min-h-screen bg-[#ffe989] relative overflow-x-hidden font-['Inter']">
      {/* Background Image Desktop*/}
      <div
        className="hidden md:block absolute left-0 right-0 h-[120vh] w-full z-0 -top-0"
        style={{
          backgroundImage: "url('/sol.png')",
          backgroundPosition: "center bottom",
          backgroundSize: "95%",
          backgroundRepeat: "no-repeat",
          margin: "0",
          backgroundClip: "content-box",
          objectFit: "cover",
        }}
      />

      {/* Background Image Mobile*/}
      <div
        className="block md:hidden absolute left-0 right-0 h-[140vh] w-full z-0 -top-44"
        style={{
          backgroundImage: "url('/sol.png')",
          backgroundPosition: "top center",
          backgroundSize: "150%",
          backgroundRepeat: "no-repeat",
          margin: "0",
          backgroundClip: "content-box",
          objectFit: "cover",
        }}
      />


      {/* Header Section */}
      <section className="relative z0 container mx-auto px-4 sm:px-6 lg:px-8 pt-10 text-center">

        {/* Logo Section Desktop*/}
        {/* <motion.div
          className="hidden md:block w-64 h-auto mx-auto -mt-20 -mb-12"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <img src="/ahead_transparent.png" alt="The News Logo" className="w-full h-full object-contain" />
        </motion.div> */}

        {/* Logo Section Mobile*/}
        {/* <motion.div
          className="block md:hidden w-44 h-auto mx-auto -mt-10 -mb-8"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <img src="/ahead_transparent.png" alt="The News Logo" className="w-full h-full object-contain" />
        </motion.div> */}

        <motion.div
          className="bg-[#f9ebe3] mt-12 rounded-3xl p-4 sm:p-8 max-w-2xl mx-auto shadow-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          <h1 className="font-bold text-3xl mb-4">o evento do the news está chegando</h1>
          <h3 className="text-[17px] max-w-lg mx-auto mb-8">
          De leitores (speakers) para leitores (audiência). O evento que vai te deixar mais inteligente. Lista de espera aberta.
          </h3>
          <div className="relative flex justify-center items-center mb-6">
            <motion.div
              className="hidden md:block absolute -bottom-40 -left-28"
              animate={{ rotate: [0, 360] }}
              transition={{ 
                duration: 8,
                ease: "linear",
                repeat: Infinity
              }}
            >
              <img
                src="/no_sugar.png"
                alt="Smarter Icon"
                className="w-32 md:w-44 h-32 md:h-44 object-contain"
              />
            </motion.div>
            {/* <h1 className="text-3xl sm:text-5xl font-extrabold">SAVE THE DATE</h1> */}

            <motion.div
              className="hidden md:block absolute -bottom-40 -right-28"
              animate={{ rotate: [0, 360] }}
              transition={{ 
                duration: 8, 
                ease: "linear", 
                repeat: Infinity
               }}
            >
              <img
                src="/smarter.png"
                alt="No Sugar Icon"
                className="w-32 md:w-44 h-32 md:h-44 object-contain"
              />
            </motion.div>
          </div>

          <motion.div
            className="text-6xl text-[#ffd000] md:text-7xl font-bold mb-8 text-center"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.5 }}
          >
            06/06
          </motion.div>

          <motion.div
            className="flex justify-center mb-6"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Button
              onClick={scrollToForm}
              className="bg-black hover:bg-gray-800 text-[#ffcf00] font-['Inter'] rounded-[15px] font-bold text-sm uppercase italic underline px-4 py-3"
            >
              quero garantir meu ingresso
            </Button>
          </motion.div>
          <motion.div
            className="flex justify-center mb-6"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Button
              onClick={takeMe}
              className="bg-black hover:bg-gray-800 text-[#ffcf00] font-['Inter'] rounded-[15px] font-bold text-sm uppercase italic underline px-4 py-3"
            >
              quero ser um speaker
            </Button>
          </motion.div>

          <h3 className="text-[17px] max-w-lg mx-auto mb-8">
            ainda não podemos dar mais informações, mas se você tiver muita vontade de estar presente nesse dia, entre para nossa lista exclusiva clicando no botão acima.
          </h3>

          <h3 className="text-[17px] font-['Inter'] italic max-w-lg mx-auto">
            <strong className="text-bold">PS:</strong> o traje é casual <strong className="text-black">black</strong> & <strong className="text-yellow-400">yellow</strong> (é sério)
          </h3>
        </motion.div>

        {/* <motion.div
          className="mt-22 hidden md:flex justify-start px-4"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6, duration: 0.5 }}
        >
          <div className="relative w-60 sm:w-80 -top-60 h-40">
            <img
              src="/shapes_left.png"
              alt="Colorful shapes"
              className="absolute left-0 bottom-0 w-full h-auto"
            />
          </div>
        </motion.div> */}

        {/* <motion.div
          className="mt-10 hidden md:flex justify-end px-4"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6, duration: 0.5 }}
        >
          <div className="relative w-60 sm:w-80 -top-60 h-40">
            <img
              src="/shapes_right.png"
              alt="Holographic shape"
              className="absolute right-0 bottom-60 w-full h-auto"
            />
          </div>
        </motion.div> */}

      </section>

      {/* 3D Objects Section Desktop */}
      {/* <section className="hidden md:block p-6 relative overflow-hidden -top-40 -mt-40 sm:-mt-80">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <motion.div
            animate={{
              y: [0, -20, 0],
            }}
            transition={{
              duration: 6,
              repeat: Number.POSITIVE_INFINITY,
              ease: "easeInOut",
            }}
            className="w-full h-full"
          >
            <img
              src="/shapes.png"
              alt="Colorful 3D shapes"
              className="object-contain"
            />
          </motion.div>
        </motion.div>
      </section> */}

      {/* 3D Objects Section Mobile */}
      {/* <section className="block md:hidden relative overflow-hidden w-screen -bottom-6">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
        >
          <motion.div
            animate={{
              y: [0, -15, 0],
              rotate: [0, 2, 0],
            }}
            transition={{
              duration: 8,
              repeat: Number.POSITIVE_INFINITY,
              ease: "easeInOut",
            }}
            className="w-full h-full"
          >
            <motion.div
              className="absolute inset-0 z-0"
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.4 }}
              transition={{ delay: 0.5 }}
            />
            <img
              src="/shapes.png"
              alt="Colorful 3D shapes"
              className="object-contain w-screen"
              style={{
                filter: "drop-shadow(0 10px 15px rgba(0,0,0,0.1))",
                WebkitFilter: "drop-shadow(0 10px 15px rgba(0,0,0,0.1))"
              }}
            />
          </motion.div>
        </motion.div>
      </section> */}

      {/* Form Section 1 */}
      <section className="container mx-auto px-4 md:mt-[500px] sm:px-6 lg:px-8 pt-10 pb-12 relative z-10" id="interesse-form">
        <div className="max-w-xl rounded-3xl top-20 md:-mt-40 mx-auto bg-[#f9ebe3] p-12 rounded-lg shadow-sm relative z-20">
          <motion.h2
            className="text-2xl md:text-3xl font-bold mb-4 flex items-center"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <div className="relative inline-block">
              <div className="absolute bottom-0 left-0 w-full h-5 bg-yellow-400"></div>
              <span className="relative text-black">
                INSIRA SEUS DADOS
              </span>
            </div>
          </motion.h2>

          <p className="text-[18px] mb-6">
            a lista de interessados será em um canal fechado do whatsapp, em que daremos informações em primeira mão — e um desconto exclusivo no ingresso.
          </p>

          <form className="space-y-4 relative z-30" onSubmit={handleSubmit1}>
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1, duration: 0.3 }}
              className="relative z-30"
            >
              <input
                type="text"
                placeholder="seu nome"
                value={formData1.nome_completo}
                onChange={(e) => setFormData1({ ...formData1, nome_completo: e.target.value })}
                className="w-full p-3 rounded-full border-4 border-[#ffcf00] bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-yellow-500 font-['Inter'] relative z-30"
                required
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.3 }}
            >
              <input
                type="email"
                placeholder="seu email"
                value={formData1.email}
                onChange={(e) => setFormData1({ ...formData1, email: e.target.value })}
                className="w-full p-3 rounded-full border-4 border-[#ffcf00] bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-yellow-500 font-['Inter']"
                required
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3, duration: 0.3 }}
            >
              <input
                type="tel"
                placeholder="seu whatsapp (com DDD)"
                value={formData1.whatsapp}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '');
                  if (value.length <= 11) {
                    const formatted = value
                      .replace(/^(\d{2})/, '($1) ')
                      .replace(/(\d{5})(\d)/, '$1-$2');
                    setFormData1({ ...formData1, whatsapp: formatted });
                  }
                }}
                className="w-full p-3 rounded-full border-4 border-[#ffcf00] bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-yellow-500 font-['Inter']"
                required
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4, duration: 0.3 }}
            >
              <input
                type="text"
                placeholder="sua empresa"
                value={formData1.empresa}
                onChange={(e) => setFormData1({ ...formData1, empresa: e.target.value })}
                className="w-full p-3 rounded-full border-4 border-[#ffcf00] bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-yellow-500 font-['Inter']"
                required
              />
            </motion.div>

            <AnimatePresence>
              {!isSuccess1 ? (
                <Button 
                  className="w-full sm:w-auto bg-[#ffcf00] text-black font-bold font-['Inter'] text-2xl rounded-[20px] px-6 py-6 hover:bg-[#ffd000]"
                  disabled={isSubmitting1}
                  type="submit"
                >
                  {isSubmitting1 ? (
                    <div className="w-6 h-6 border-4 border-black border-t-transparent rounded-full animate-spin" />
                  ) : (
                    'confirmar'
                  )}
                </Button>
              ) : (
                <motion.div 
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  className="bg-[#f9ebe3] p-6 rounded-[20px] border-4 border-[#ffcf00] shadow-md text-center"
                >
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ type: "spring", duration: 0.5 }}
                    className="flex items-center justify-center w-16 h-16 rounded-full bg-[#ffcf00] text-black mx-auto mb-4"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </motion.div>
                  <p className="text-2xl font-bold text-black">resposta enviada com sucesso! 🎉</p>
                  <p className="text-lg text-black mt-2 font-['Inter']">em breve entraremos em contato com mais informações!</p>
                </motion.div>
              )}
            </AnimatePresence>

            {error1 && (
              <motion.p
                initial={{ opacity: 0, y: 5 }}
                animate={{ opacity: 1, y: 0 }}
                className="text-red-500 text-center mt-2"
              >
                {error1}
              </motion.p>
            )}
          </form>
        </div>
      </section>

      {/* Seção de rodapé com direitos reservados */}
      <section className="container mx-auto px-4 sm:px-6 lg:px-8 py-16 relative">
        <div className="text-center md:hidden">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3, duration: 0.3 }}
          >
            {/* <h2 className="text-black font-bold text-sm">® the news | Direitos Reservados</h2> */}
          </motion.div>
        </div>
      </section>
    </main>
  )
}

